export const mail = {
  '站内信': 'Messages internes',
  '返回': 'Retour',
  '有未读信息': '{amount} message(s) non lu(s)',
  '全部标记为已读': 'Tout marquer comme lu',
  '隐藏已读消息': 'Masquer les messages lus',
  '展开': 'Déplier',
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/fr.js